import { AppLayout, AppLayoutProps } from '@src/components/sco/AppLayout';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { MatchingContextProvider } from '@src/components/sco/Matching/Layout/MatchingContext';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import React, { ReactNode, useMemo } from 'react';
type MatchingLayoutProps = {
  appLayoutProps?: AppLayoutProps;
  asidePanel?: ReactNode;
  hideSiteNav?: boolean;
  mainPanel?: ReactNode;
  navPanel?: ReactNode;
  navPanelProps?: AppLayoutPanelProps;
};
export const MatchingLayout = (props: MatchingLayoutProps) => {
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState<boolean>(!!props.asidePanel);
  const pathname = usePathname();
  const queryParams = useSearchParams();
  const params = useParams();
  const {
    currentUser
  } = useCurrentUser();
  const panels = useMemo<Array<AppLayoutPanelProps | any>>(() => [props.navPanel ? {
    id: 'matching-nav',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'right',
    defaultWidth: 280,
    minWidth: 200,
    maxWidth: 400,
    children: props.navPanel,
    isPanelOpen: currentUser?.isGuest || params.variantKey || queryParams.get('v') ? false : true,
    isDrawerOpen: false,
    ...props.navPanelProps
  } : null, {
    id: 'matching-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true,
    resetScrollOnPathChange: true
  }, {
    id: 'matching-aside',
    useDrawerBreakpoints: {
      base: true,
      lg: false
    },
    isResizable: true,
    resizeHandlePosition: 'left',
    drawerPlacement: 'right',
    defaultWidth: 420,
    minWidth: 320,
    maxWidth: 480,
    children: props.asidePanel,
    isPanelOpen: !!queryParams.get('threadId'),
    onPanelClose: () => {
      setAsidePanelIsOpen(false);
    },
    isDrawerOpen: false
  }].filter(Boolean), [pathname, asidePanelIsOpen]);
  return <MatchingContextProvider>
      <AppLayout header={props.hideSiteNav ? null : <ScoSiteNavBar />} id={'matching'} panels={panels} {...props.appLayoutProps} />
    </MatchingContextProvider>;
};